import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './masterlayout/header/header.component';
import { FooterComponent } from './masterlayout/footer/footer.component';
import { HomeComponent } from './masterlayout/home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { ChartsModule } from 'ng2-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './common/shared.module';
import { LoginComponent } from './login/login.component';
// import {TableModule} from 'primeng/table';
// import {ButtonModule} from 'primeng/button';
 import {PaginatorModule} from 'primeng/paginator';
 import {ScrollingModule} from '@angular/cdk/scrolling';
 import {TableModule} from 'primeng/table';
 import { DatePipe } from '@angular/common';
 registerLocaleData(localeIn);


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    // OrganizationComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ChartsModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    PaginatorModule,
    FormsModule,
    TableModule
  ],
   exports: [PaginatorModule,TableModule],
   providers: [DatePipe,{ provide: LOCALE_ID, useValue: 'en-IN' }],
   bootstrap: [AppComponent],
})
export class AppModule {}
